(function () {
  function initSlider(root) {
    if (!root || root.dataset.subcollectionsReady === 'true') return;
    root.dataset.subcollectionsReady = 'true';

    const viewport = root.querySelector('[data-slider-viewport]');
    const track = root.querySelector('[data-slider-track]');
    const prevBtn = root.querySelector('[data-slider-prev]');
    const nextBtn = root.querySelector('[data-slider-next]');
    const slides = Array.from(root.querySelectorAll('[data-slider-slide]'));

    if (!viewport || !track || !slides.length) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    let currentIndex = 0;

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return Number.isNaN(gap) ? 0 : gap;
    };

    const getSlideSize = () => {
      const first = slides[0];
      return first ? first.getBoundingClientRect().width : 0;
    };

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    const contentFits = () => {
      const slideW = getSlideSize();
      if (!slideW) return true;
      const gap = getGap();
      const total = slides.length * slideW + Math.max(0, slides.length - 1) * gap;
      return total <= viewport.getBoundingClientRect().width + 1;
    };

    const maxIndex = () => {
      if (contentFits()) return 0;
      const slideW = getSlideSize();
      const gap = getGap();
      const viewportW = viewport.getBoundingClientRect().width;
      const perView = Math.max(1, Math.floor((viewportW + gap) / (slideW + gap)));
      return Math.max(0, slides.length - perView);
    };

    const applyStaticState = () => {
      const isStatic = contentFits();
      track.classList.toggle('is-centered', isStatic);
      track.classList.toggle('is-centered-desktop', isStatic);
      root.classList.toggle('is-static', isStatic);
      root.classList.toggle('is-static-desktop', isStatic);
      if (isStatic) {
        track.style.transform = 'translate3d(0, 0, 0)';
      }
    };

    const updateButtons = () => {
      if (!prevBtn || !nextBtn) return;

      if (contentFits()) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }

      prevBtn.style.display = '';
      nextBtn.style.display = '';

      const maxI = maxIndex();
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxI;

      const noScroll = maxI === 0;
      prevBtn.style.visibility = noScroll ? 'hidden' : 'visible';
      nextBtn.style.visibility = noScroll ? 'hidden' : 'visible';
    };

    const translateToIndex = (idx, animate = true) => {
      applyStaticState();

      if (contentFits()) {
        currentIndex = 0;
        track.style.transition = '';
        track.style.transform = 'translate3d(0, 0, 0)';
        updateButtons();
        return;
      }

      currentIndex = clamp(idx, 0, maxIndex());
      const x = (getSlideSize() + getGap()) * currentIndex;

      if (!animate) track.style.transition = 'none';
      track.style.transform = `translate3d(${-x}px, 0, 0)`;
      if (!animate) requestAnimationFrame(() => (track.style.transition = ''));

      updateButtons();
    };

    if (prevBtn) prevBtn.addEventListener('click', () => translateToIndex(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => translateToIndex(currentIndex + 1));

    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', (e) => {
      if (contentFits()) return;
      if (e.key === 'ArrowLeft') translateToIndex(currentIndex - 1);
      if (e.key === 'ArrowRight') translateToIndex(currentIndex + 1);
    });

    let startX = 0;
    let startTranslate = 0;
    let isDragging = false;

    const getCurrentTranslate = () => {
      const match = track.style.transform.match(/translate3d\((-?\d+(?:\.\d+)?)px/);
      return match ? parseFloat(match[1]) : 0;
    };

    const onPointerDown = (e) => {
      if (contentFits()) return;
      isDragging = true;
      track.classList.add('is-dragging');
      startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      startTranslate = getCurrentTranslate();
    };

    const onPointerMove = (e) => {
      if (!isDragging) return;
      const clientX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      const delta = clientX - startX;
      track.style.transform = `translate3d(${startTranslate + delta}px, 0, 0)`;
    };

    const onPointerUp = (e) => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      const clientX = e.clientX || (e.changedTouches && e.changedTouches[0].clientX) || startX;
      const delta = clientX - startX;
      const threshold = Math.max(40, getSlideSize() * 0.2);
      if (delta > threshold) translateToIndex(currentIndex - 1);
      else if (delta < -threshold) translateToIndex(currentIndex + 1);
      else translateToIndex(currentIndex);
    };

    track.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    track.addEventListener('touchmove', onPointerMove, { passive: true });
    track.addEventListener('touchend', onPointerUp);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => translateToIndex(currentIndex, false), 120);
    });

    translateToIndex(0, false);
  }

  function initAll() {
    document.querySelectorAll('[data-subcollections-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-subcollections-slider]');
    if (root) {
      root.dataset.subcollectionsReady = 'false';
      initSlider(root);
    }
  });
})();
